/**
 * Monotonic clock helper. Use for elapsed-duration comparisons that must be
 * unaffected by NTP wall-clock jumps, DST, or suspend/resume drift.
 *
 * Pi 5 has no RTC: at boot the wall clock can jump by months when NTP
 * eventually syncs. With Date.now(), an interval like
 *   if (Date.now() - lastRunAt > 24h) ...
 * either fires immediately (if the clock jumps forward) or never fires
 * (if it jumps backward). monotonicMs() never moves backward and never
 * skips forward by an arbitrary amount.
 *
 * Use Date.now() ONLY for timestamps reported externally (server payloads,
 * log lines) where the wall clock is what consumers expect.
 */
const usePerfNow = typeof performance !== 'undefined' && typeof performance.now === 'function';
export function monotonicMs() {
    if (usePerfNow) {
        return performance.now();
    }
    // node fallback: hrtime.bigint() returns nanoseconds
    return Number(process.hrtime.bigint() / 1000000n);
}
//# sourceMappingURL=MonoClock.js.map